<h1>{{ ("reports" | i18n) || "Berichte" | titlecase }}</h1>
<div
  class="reports"
  *ngIf="customer$ | async as customer">
  <p
    *ngIf="areAllReportsDisabled(customer)"
    class="admin-reports__all-disabled-warning"
    role="alert">
    {{
      ("adminReportsAllDisabledWarning" | i18n) ||
        "Alle Berichte sind ausgeblendet. Nutzer sehen in der Berichte-Übersicht keine Downloads mehr."
    }}
  </p>
  <div class="row mt-3">
    <div
      class="col col-12 col-md-6 mb-3"
      *ngFor="let report of reportKeys; trackBy: trackByReport">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + report | i18n) || report
        }}</mat-card-title>
        <mat-card-content>
          <mat-checkbox
            color="primary"
            [checked]="isReportEnabled(report, customer)"
            (change)="
              onReportVisibilityChange(report, $event.checked, customer._id)
            ">
            {{
              ("reportEnabledInOverview" | i18n) ||
                "Bericht in der Übersicht anzeigen"
            }}
          </mat-checkbox>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
